import { Component, OnInit } from '@angular/core';
import { PopupService } from '../../services/popup/popup.service';
import { NavigationService } from '../../services/navigation/navigation-onboarding.service';
import { CopyService } from '../../services/copies/copy.service';
import { FirmlyApprovedService } from '../../services/firmly-approved/firmly-approved.service';
import { OFFERS_STATUS_CONST } from '../../constants/offers-status.constants';
import { EVENT as EVENT_POPUP } from '../../constants/dali-popup.constants';
import { DaliService } from '@dali/tagger-ng8';
import { BitacoraService } from '../../services/bitacora/bitacora.service';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
})
export class PopupComponent implements OnInit {
  copies: any;

  constructor(
    private popupService: PopupService,
    private navigationService: NavigationService,
    private firmlyApprovedService: FirmlyApprovedService,
    private copiesServices: CopyService,
    private daliService: DaliService,
    private bitacoraService: BitacoraService,

  ) {
    this.copies = this.copiesServices.copies.firmly_approved_popup;
  }

  ngOnInit(): void {
    this.sendShowPopupEvent();
  }

  /**
   * Metodo que oculta el popup de la oferta de aprobados en firme.
   * @param continueFlow parametro que indica si se debe continuar el flujo.
   * @param isRedirecting parametro que indica si se debe redireccionar hacia la oferta de aprobados en firme.
   */
  hidePopup(continueFlow: boolean, isRedirecting: boolean = false): void {
    this.popupService.hidePopup(continueFlow, isRedirecting);
  }

  /**
   * Metodo que apaga la oferta de aprobados en firme cuando se presiona el boton de "No me interesa".
   */
  turnOffFirmlyApprovedOffer() {
    this.sendNotInterestedPopupButtonEvent();
    this.hidePopup(true);
    const products = this.firmlyApprovedService.getProductsFirmlyApproved();
    const productsType = {
      freeInvestment: 'ORD',
      creditCard: 'TCR',
      revolvingCredit: 'CRP',
    };
    let product_code = '';
    products.forEach((product: any) => {
      product_code = `${product_code}${productsType[product.product_type]},`;
    });
    product_code = product_code.slice(0, product_code.length - 1);
    const product_list: [any] = [{
      product_code,
    }];
    this.bitacoraService.saveDataInBitacora('popup_af_rech');
    this.firmlyApprovedService.turnOffOffer(OFFERS_STATUS_CONST.REFUSE_ONBOARDING.CODE, product_list);
  }

  /**
   * Metodo encargado de redireccionar hacia la oferta de aprobados en firme.
   */
  async redirectToFirmlyApprovedOffer() {
    try {
      console.warn('call to method redirectToFirmlyApprovedOffer');
      this.sendKnowMorePopupButtonEvent();
      this.hidePopup(false, true);
      this.bitacoraService.saveDataInBitacora('popup_af_avan');
      this.popupService.continueWithFirmlyApproved = true;
      await this.navigationService.nextStep('234');
    } catch (error) {
      console.warn('Error redirecting to firmlyApproved offers page:', error);
    }
  }

  /* ------------------ Taggeo ------------------ */

  sendShowPopupEvent(): void {
    const event = {
      category: {
        module: EVENT_POPUP.customCategory.module.body,
        type: EVENT_POPUP.customCategory.type.content,
        position: EVENT_POPUP.customCategory.position.center,
      },
      action: EVENT_POPUP.customAction.show,
      label: EVENT_POPUP.pv10E9customLabel,
    };
    this.daliService.trackEvent(event);
  }

  sendKnowMorePopupButtonEvent(): void {
    const event = {
      category: {
        module: EVENT_POPUP.customCategory.module.body,
        type: EVENT_POPUP.customCategory.type.button,
        position: EVENT_POPUP.customCategory.position.center,
      },
      action: EVENT_POPUP.customAction.click,
      label: EVENT_POPUP.pv10E10customLabel,
    };
    this.daliService.trackEvent(event);
  }

  sendNotInterestedPopupButtonEvent(): void {
    const event = {
      category: {
        module: EVENT_POPUP.customCategory.module.body,
        type: EVENT_POPUP.customCategory.type.button,
        position: EVENT_POPUP.customCategory.position.center,
      },
      action: EVENT_POPUP.customAction.click,
      label: EVENT_POPUP.pv10E11customLabel,
    };
    this.daliService.trackEvent(event);
  }
}
